import useProductStore from '@/stores/productStore';

import ReviewFreePrice from './ReviewFreePrice';
import ReviewOpenPrice from './ReviewOpenPrice';
import ReviewPrice from './ReviewPrice';
import ReviewModeSubscription from './ReviewSubscription';

enum enPaymentType {
  OPEN = 'open',
  ONE_TIME = 'oneTime',
  FREE = 'free',
  SUBSCRIPTION = 'subscription'
}

const ReviewByBillingModel = () => {
  const type = useProductStore(d => d.payment.type);

  return (
    <div>
      {type === enPaymentType.OPEN && <ReviewOpenPrice />}
      {type === enPaymentType.ONE_TIME && <ReviewPrice />}
      {type === enPaymentType.FREE && <ReviewFreePrice />}
      {type === enPaymentType.SUBSCRIPTION && <ReviewModeSubscription />}
    </div>
  );
};

export default ReviewByBillingModel;
